import { useCallback } from 'react'

import { trackEvent } from 'utils/tracking'

const TRACK_NAME = 'AILeadQualificationSkillConfiguration'

export enum AILQTrackAction {
  GENERATE_ATTRIBUTES = 'generate_attributes',
  SAVE_ATTRIBUTES = 'save_attributes',
}

export const useLQTracking = () => {
  const trackLQ = useCallback((action: AILQTrackAction, extraProps = {}) => {
    trackEvent(TRACK_NAME, {
      action,
      ...extraProps,
    })
  }, [])

  return {
    trackLQ,
  }
}
